'use client'

import { ReactNode, useEffect, useRef } from "react";

type SidebarProps = {
    children: ReactNode,
    className?: string
}

export default function Sidebar({
    children,
    className = ''
}: SidebarProps) {

    const refSidebar = useRef<HTMLElement>(null)

    useEffect(() => {
        document.querySelector('main').classList.add('has-sticky')

        return () => {
            document.querySelector('main')?.classList.remove('has-sticky')
        }
    }, [])

    useEffect(() => {
        function getOffset(el) {
            const rect = el.getBoundingClientRect();
            return {
                left: rect.left + window.scrollX,
                top: rect.top + window.scrollY,
            };
        }
        function initEncartTop() {
            if (!refSidebar.current) return
            if (
                getComputedStyle(document.querySelector(".encart")).position ===
                "sticky"
            ) {
                refSidebar.current.style.marginTop =
                    getOffset(document.querySelector("h1")).top -
                    getOffset(refSidebar.current.parentElement).top +
                    5 +
                    "px";
                    refSidebar.current.style.top =
                    document.querySelector("header").offsetHeight + 40 + "px";
                return;
            }
            refSidebar.current.style.marginTop = "initial";
            refSidebar.current.style.top = "0px";
        }
        initEncartTop();
        addEventListener("resize", (event) => {
            initEncartTop();
        });

        return () => {
            removeEventListener("resize", (event) => {
                initEncartTop();
            })
        }
    }, [])

    return (
        <section ref={refSidebar} className={"encart " + className}>
            {children}
        </section>
    )
}